import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M3.144 5.856A.483.483 0 0 0 3.5 6h15c.142 0 .26-.048.356-.143A.482.482 0 0 0 19 5.5a.484.484 0 0 0-.144-.357A.483.483 0 0 0 18.5 5h-15a.485.485 0 0 0-.356.143A.482.482 0 0 0 3 5.5c0 .142.048.261.144.357Zm.018 6.504a.579.579 0 0 0 .4.145h16.875c.16 0 .293-.048.401-.144a.46.46 0 0 0 .162-.358.462.462 0 0 0-.162-.358.579.579 0 0 0-.4-.145H3.563a.581.581 0 0 0-.401.144.46.46 0 0 0-.162.358c0 .142.054.262.162.358ZM3.5 19a.483.483 0 0 1-.356-.144.485.485 0 0 1-.144-.357c0-.142.048-.26.144-.356A.485.485 0 0 1 3.5 18h15c.142 0 .26.048.356.144a.484.484 0 0 1 .144.357c0 .142-.048.26-.144.356A.484.484 0 0 1 18.5 19h-15Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }